export class OrderItemDetail {
  quantity: number;
  amount: number;
  voucherValueId: number;
}
